import { jsx as _jsx } from "react/jsx-runtime";
import { Text } from '../../../Text/Text';
import { Box } from '../../../layout/Box';
import { getRenderExpansionRowElement } from './getRenderExpansionRowElement';
export const renderGroupedData = (groupData, options) => {
    const { depth = 0, columns, rowKeyExtractor, expandedKey, hasAllRowsExpanded, renderDetail, setExpandedKey, renderLeftRowElement, rowHeaderTestId, getHasRowDetail, } = options;
    const tableHasDetail = !!renderDetail;
    const renderExpansionRowElement = getRenderExpansionRowElement({
        rowKeyExtractor,
        rowHeaderTestId,
        renderDetail,
        renderLeftRowElement,
        getHasRowDetail,
        columns,
        hasAllRowsExpanded,
        tableHasDetail,
        expandedKey,
        setExpandedKey,
    });
    const renderRows = (rows) => rows.map(renderExpansionRowElement);
    const renderHeaders = (groupedData, currentDepth) => {
        if (Object.keys(groupedData).length === 0) {
            return [];
        }
        return Object.entries(groupedData).flatMap(([key, value]) => {
            const textVariant = currentDepth === 0 ? 'h4' : 'b2';
            const spacingTopVariant = currentDepth === 0 ? '2' : '1/2';
            const header = (_jsx(Box, { spacingTop: spacingTopVariant, children: _jsx(Text, { variant: textVariant, children: key }) }, key));
            return [
                header,
                ...renderGroupedData(value, {
                    ...options,
                    depth: currentDepth + 1,
                }),
            ];
        });
    };
    const isArrayGroupData = Array.isArray(groupData);
    const renderedElements = isArrayGroupData
        ? renderRows(groupData)
        : renderHeaders(groupData, depth);
    return renderedElements;
};
